export default __webpack_public_path__ + "static/dragontimes_banner-8e851a6e9630fc82adb6ad84b2ee2a88.jpg";